export { default } from './Pill'



// WEBPACK FOOTER //
// ./src/modules/common/components/pill/index.js